// extracted by mini-css-extract-plugin
export default {"stars":"AverageStarRating_stars__yR0Ry","starIcon":"AverageStarRating_starIcon__KY+vw"};